import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Typography } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { functionNameFor } from '../../services/platformRoutesApi';
import { PlatformRouteCard, RouteDraft, RouteSetupFields, slugProblem, useRouteDefaults } from './PlatformRouteCard';

/** Function builder panel for admins: the route a new platform function will be served at
 * (`?platform=1`), or the saved function's route settings. */
export const PlatformRouteAccordion: React.FC<{
  functionId?: string;
  draft: RouteDraft;
  onDraftChange: (d: RouteDraft) => void;
}> = ({ functionId, draft, onDraftChange }) => {
  const defaults = useRouteDefaults();
  const problem = draft.slug ? slugProblem(draft.slug, defaults) : 'Pick a route name';
  return (
    <Accordion defaultExpanded sx={{ mt: 1 }} TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography sx={{ fontWeight: 600 }}>🚀 Platform route</Typography>
          <Typography variant="body2" color="text.secondary">
            {functionId ? 'Serve this function on the Passio platform API' : draft.slug ? `/napi/tools/${draft.slug}` : 'Served on the Passio platform API'}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        {functionId ? (
          <PlatformRouteCard functionId={functionId} />
        ) : (
          <>
            <Alert severity="info" variant="outlined" sx={{ mb: 2 }}>
              {problem
                ? 'Saving creates the function, then serves it at the route below with the platform defaults.'
                : `Saving creates ${functionNameFor(draft.slug)}, then serves it at /napi/tools/${draft.slug} with the platform defaults.`}{' '}
              Save while signed in to the platform account.
            </Alert>
            <RouteSetupFields draft={draft} onChange={onDraftChange} defaults={defaults} />
          </>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default PlatformRouteAccordion;
